// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ItemsInner } from "./ItemsInner";
import {
  ItemsInnerFromJSON,
  ItemsInnerFromJSONTyped,
  ItemsInnerToJSON,
  ItemsInnerToJSONTyped,
} from "./ItemsInner";

/**
 *
 * @export
 * @interface CursorPageFileList
 */
export interface CursorPageFileList {
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  items: Array<ItemsInner>;
  /**
   *
   */
  limit?: number | null;
}

/**
 * Check if a given object implements the CursorPageFileList interface.
 */
export function instanceOfCursorPageFileList(value: object): value is CursorPageFileList {
  if (!("items" in value) || value["items"] === undefined) return false;
  return true;
}

export function CursorPageFileListFromJSON(json: any): CursorPageFileList {
  return CursorPageFileListFromJSONTyped(json, false);
}

export function CursorPageFileListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CursorPageFileList {
  if (json == null) {
    return json;
  }
  return {
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    items: (json["items"] as Array<any>).map(ItemsInnerFromJSON),
    limit: json["limit"] === undefined ? undefined : json["limit"] === null ? null : json["limit"],
  };
}

export function CursorPageFileListToJSON(json: any): CursorPageFileList {
  return CursorPageFileListToJSONTyped(json, false);
}

export function CursorPageFileListToJSONTyped(
  value?: CursorPageFileList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    next: value["next"],
    items: (value["items"] as Array<any>).map(ItemsInnerToJSON),
    limit: value["limit"],
  };
}
